import React, { useState, useEffect } from 'react';
import { InputLabel, TextField, Select, MenuItem, Button, Grid, Box, Typography, InputAdornment, IconButton } from '@mui/material';
import { useFormik } from "formik"
import { Link } from 'react-router-dom';
import * as yup from 'yup';
import { Link as MUIlink } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { ArrowLeftRounded, Visibility, VisibilityOff } from '@mui/icons-material';




const validationSchema = yup.object({
  fullname: yup
    .string('Enter your name')
    .required('Name is required'),
  phone_number: yup
    .string('Enter your phone number')
    .min(10, 'Enter a valid phone number')
    .required('Phone number is required')
    .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Enter a valid phone number"
      ),
  email: yup
    .string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
  password: yup
    .string('Enter your password')
    .min(9, 'Password should be of minimum 9 characters length')
    .required('Password is required')
    .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{9,}$/,
        "Password must include atleast one uppercase, one lowercase, one numeric and one special character [@$!%*#?&]"
      ),
  
  confirmedPassword: yup
    .string('Enter your password')
    .min(9, 'Password should be of minimum 9 characters length')
    .required('Password is required')
    .oneOf([yup.ref('password'), null], 'Passwords must match')
});

const SignupFormRes = ({signupInit,setEmailMain,setFullnameMain,setPhonenumberMain,processLoader}) => {
  const [showPassword, setShowPassword] = useState(false);
  const formik = useFormik({
    initialValues: {
      fullname: '',
      countryCode: "+91",
      phone_number: '',
      email: '',
      password: '',
      confirmedPassword: ""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
       setEmailMain(values.email)
       setFullnameMain(values.fullname)
       setPhonenumberMain(values.countryCode+values.phone_number)
      signupInit(values.email,values.password)
     
    },
  });

  const handleClickShowPassword = () => {
    let input = document.getElementById("password");
    input.type === "password" ? input.type = "text" : input.type = "password";
    setShowPassword(!showPassword);
  }

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography sx={{ marginTop: 2 }} variant="h4" align="center">
              Sign Up
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputLabel><Typography variant="h6">Full Name</Typography></InputLabel>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                id="fullname"
                name="fullname"
                inputProps={{ maxLength: 255}}
                value={formik.values.fullname}
                placeholder
                onChange={formik.handleChange}
                error={formik.touched.fullname && Boolean(formik.errors.fullname)}
                helperText={formik.touched.fullname && formik.errors.fullname}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputLabel><Typography variant="h6">Phone Number</Typography></InputLabel>
            <Grid item xs={12} sm={12}>
             <Grid container item>
                           <Grid item xs={3} sm={4}>
                             <TextField
                               fullWidth
                               select
                               id="countryCode"
                               name="countryCode"
                               inputProps={{ maxLength: 30 }}
             
                               value={formik.values.countryCode}
                               onChange={formik.handleChange}
                               error={formik.touched.countryCode && Boolean(formik.errors.countryCode)}
                               helperText={formik.touched.countryCode && formik.errors.countryCode}
                             >
                               {
                                 ["+91", "+63"].map(
                                   (item) => (<MenuItem value={item}>{item}</MenuItem>)
                                 )
                               }
                             </TextField>
                           </Grid>
                           <Grid item xs={9} sm={8}>
                             <TextField
                               fullWidth
                               id="phone_number"
                               name="phone_number"
                               inputProps={{ maxLength: 10, style: { textAlign: "right" } }}
             
                               value={formik.values.phone_number}
                               onChange={formik.handleChange}
                               error={formik.touched.phone_number && Boolean(formik.errors.phone_number)}
                               helperText={formik.touched.phone_number && formik.errors.phone_number}
                             />
                           </Grid>
                         </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputLabel><Typography variant="h6"> Email address</Typography></InputLabel>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                id="email"
                name="email"
                inputProps={{ maxLength: 255}}
                value={formik.values.email}
                placeholder
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputLabel><Typography variant="h6">Create Password</Typography></InputLabel>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                id="password"
                name="password"
                inputProps={{ maxLength: 255}}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                type="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputLabel><Typography variant="h6"> Confirm Password</Typography></InputLabel>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                id="confirmedPassword"
                name="confirmedPassword"
                inputProps={{ maxLength: 255}}
                type="password"
                value={formik.values.confirmedPassword}
                onChange={formik.handleChange}
                error={formik.touched.confirmedPassword && Boolean(formik.errors.confirmedPassword)}
                helperText={formik.touched.confirmedPassword && formik.errors.confirmedPassword}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <LoadingButton  style={{textTransform: 'none'}} loading={processLoader} loadingPosition="center" color="primary" variant="contained" fullWidth type="submit">
              Generate Verification Code
            </LoadingButton>
          </Grid>
          <Grid item xs={12} sm={12}>


          </Grid>
        </Grid>


      </form>
    </>
  )
}

export default SignupFormRes